// extracted by mini-css-extract-plugin
module.exports = {"container":"Panel_container__2s5AK"};